import * as localStorage from "../device/localStorage";
import {setItem} from "../device/localStorage";
import {logger} from "../log/logger";

//local storage key
const SIGN_IN_DATA_KEY = "signInData";

/**
 * Data that is stored and retrieved from local storage to facilitate not having to sign in each time you open the app.
 */
interface ISignInData {
  userId: number;
  sessionToken: string;
  sessionId: string;
  tokenExpiryTime: number;
  version: string; //when sign in data changes, check version. eg. going form startSession to authentication endpoint.
  soundsliceUserIdentifier: string;
}

/**
 * Attempts to get data returned from sign-in/start-session that is stored in local storage so users only have to log in once a year.
 */
export function getSignInDataFromLocalStorage(){
  const signInDataString = localStorage.getItem(SIGN_IN_DATA_KEY);
  let data: ISignInData | undefined = undefined;
  if(signInDataString){
    try{
      data = JSON.parse(signInDataString);
    }catch(e){
      logger.storageLocal.error({message: `unable to parse sign in data from local storage.` + signInDataString});
    }
  }
  return data;
}

export function deleteSignInData(){
  localStorage.setItem(SIGN_IN_DATA_KEY, undefined);
}

/**
 * Stores data returned from sign in to local storage, so users only have to log in once a year (assumption being that the token lasts a year)
 * @param userId - returned from start session
 * @param sessionToken - returned from start session
 * @param sessionId - returned from start session
 * @param tokenExpiryTime - epoch ms time when token is set to expire. currently we assume a year. ultimately should be returned from the backend.
 * @param version - when data stored changes, we use version to invalidate stored data and force a new sign in
 * @param soundsliceUserIdentifier - unique id sent to soundslice iframe as &u=example
 */
export function saveSignInDataToLocalStorage({userId, sessionToken, sessionId, tokenExpiryTime, version, soundsliceUserIdentifier}: ISignInData){
  setItem(SIGN_IN_DATA_KEY, {userId, sessionToken, sessionId, tokenExpiryTime, version, soundsliceUserIdentifier});
}
